import script from "./giftCodeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./giftCodeView.vue?vue&type=script&setup=true&lang=ts"

import "./giftCodeView.vue?vue&type=style&index=0&id=88b35b80&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88b35b80"]])

export default __exports__